module.exports = __webpack_public_path__ + "static/media/details2.2d964930.svg";